import React from 'react'
import PropTypes from 'prop-types'
import { SuccessIcon, InfoIcon, WarningIcon, ErrorIcon } from '@ow/icons'
import StyledIcon from './styled/icon'

const Icon = (props) => {
  const { type } = props
  if (type === 'success') {
    return (
      <StyledIcon>
        <SuccessIcon width={20} height={20} />
      </StyledIcon>
    )
  }
  if (type === 'error') {
    return (
      <StyledIcon>
        <ErrorIcon width={20} height={20} />
      </StyledIcon>
    )
  }
  if (type === 'warning') {
    return (
      <StyledIcon>
        <WarningIcon width={20} height={20} />
      </StyledIcon>
    )
  }
  return (
    <StyledIcon>
      <InfoIcon width={20} height={20} />
    </StyledIcon>
  )
}

Icon.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
}

Icon.defaultProps = {
  type: 'info',
}
export default Icon
